const FIELD_ORDER = [
  'fullName', 'email', 'phone', 'age', 'sex', 'church',
  'ageGroup', 'arrivalDate', 'transport', 'room', 'status',
]

function field(value) {
  return `"${String(value ?? '').replaceAll('"', '""')}"`
}

export function attendeesToCsv(rows, headers) {
  const lines = [headers.map(field).join(',')]
  for (const row of rows) {
    lines.push(FIELD_ORDER.map(key => field(row[key])).join(','))
  }
  return lines.join('\n')
}
